import Store from '@common/Store.js';
import '@common/DarkModeAuto.js';
import DarkModeSwitch from '@common/switch.js';
import MenuSwitch from './other/menu-switch.js';
import WPDarkMode from '@common/WPDarkMode.js';
import Base from '@common/Base.js';
import './other/elementor.js'
// import Color from '../common/Color.js';

class CommonAdmin extends Base {
    events(){    
        // Switches.
        DarkModeSwitch.init();
        
        // Menu switch for admin.
        MenuSwitch.init()
    }

    ready(){
        
        if ( [1, '1'].includes(wp_dark_mode_admin_json.is_excluded) ) {
            return;
        }

        // Follow admin panel dark mode.
        this.handleExcludes()

        this.initDarkMode();

        this.listenSwitch();

        this.listenLocks();
    }

    handleExcludes(){
        // Exclude the following elements
        const elements = document?.querySelectorAll(
            `.wp-dark-mode-ignore, .wp-dark-mode-switch, #adminmenumain, #adminmenuwrap, #adminmenuback, #adminmenu, .components-form-toggle,
            .jp-masthead__logo-link`);
        if (elements) {
            // Log('Ignore elements', elements)
            elements.forEach(element => {
                const ignoreRecursively = el => {
    
                    // Bail, if element is not valid.
                    if ( ! el ) return;
    
                    // If el not intance of html.
                    if ( ! (el instanceof HTMLElement) ) {
                        return;
                    }
    
                    // Bail, if element has .wp-dark-mode-include class.
                    // if ( el.classList.includes('wp-dark-mode-include') ) return;
    
    
                    // Log('current el', el);

                    
                    // Add class.
                    el.classList.add('wp-dark-mode-ignore');
    
                    // // if has background color, make it important.
                    // const { backgroundColor, color, borderColor } = window.getComputedStyle(el) || {};
    
                    // // Log('backgroundColor', backgroundColor, color, borderColor);
                    
                    // if ( backgroundColor !== 'rgba(0, 0, 0, 0)' ) {
                    // 	el.style.backgroundColor = `${backgroundColor} !important`;
                    // }
    
                    // // If has color, border color, make it important.
                    // if ( color !== 'rgba(0, 0, 0, 0)' ) {
                    // 	el.style.color = `${color} !important`;
                    // }
    
                    // // If has border color, make it important.
                    // if ( borderColor !== 'rgba(0, 0, 0, 0)' ) {
                    // 	el.style.borderColor = `${borderColor} !important`;
                    // }
    
                    // if has children, apply recursively.
                    if ( el.childNodes && el.childNodes.length ) {
                    	el.childNodes.forEach(child => {
                    		ignoreRecursively(child);
                    	});
                    }
                }
    
                ignoreRecursively(element);
            });
        }
    
    }

    throttled = null

    /**
     * Init dark mode
     */
    initDarkMode(){

        // Remove loading attribute.
        this.html?.removeAttribute('data-wp-dark-mode-loading');
    

        // On change of dark mode.
        WPDarkMode.onChange(() => {
            this.applyMode( WPDarkMode.isActive );

            // Update switch.
            const switchElement = document.querySelector('.wp-dark-mode-admin-bar-switch .switch');

            if ( switchElement ) {
                switchElement.classList.toggle('active', WPDarkMode.isActive);
            }

            // Set store.
            Store.set('admin', WPDarkMode.isActive);
        });


        if ( wp_dark_mode_admin_json.options?.admin_enabled ) {
           
            // Apply dark mode if saved.
            const is_saved = Store.get('admin') === true || Store.get('admin') === 'true';
            // console.log('is_saved', is_saved);
            
            if ( is_saved ) {
                WPDarkMode.activate();
                this.applyMode( true );
            }

        }
    }

    /**
     * Apply dark mode
     */
    applyMode = ( dark = true ) => {
        if ( dark ) {
            DarkModeAuto.enable({
                brightness: 100,
                contrast: 90,
                sepia: 10,
            }, {
                ignoreInlineStyle: '.wp-dark-mode-ignore, .wp-dark-mode-switch, #adminmenumain, #adminmenuwrap, #adminmenuback, #adminmenu',
            });
        } else {
            DarkModeAuto.disable();
        }
    }

    listenSwitch(){
        document.addEventListener('click', (e) => {
            if ( !e.target.closest('.wp-dark-mode-admin-bar-switch') ) return;

            console.log('barSwitch', WPDarkMode.isActive);
            if ( !WPDarkMode.isActive ) {
                WPDarkMode.activate();
            } else {
                WPDarkMode.deactivate();
            }
        });
    }

    listenLocks(){
        // When clicked on wp-dark-mode-locked, show notice.
        document.addEventListener('click', (e) => {
            if ( !e.target.closest('.wp-dark-mode-locked') ) return;
            window.WPDarkModePromo.show()
        })
    }
}

export default new CommonAdmin();

// window.addEventListener('DOMContentLoaded', () => {

//     // Exclude the following elements
//     const elements = document?.querySelectorAll('.wp-dark-mode-ignore, .wp-dark-mode-switch, #adminmenumain, #adminmenuwrap, #adminmenuback, #adminmenu');
//     if (elements) {
//         elements.forEach(element => {
//             const ignoreRecursively = el => {
//                 el.classList.add('wp-dark-mode-ignore');
//             }

//             ignoreRecursively(element);
//         });
//     }
    
//     // Take action if the user has saved the dark mode 
//     const isSaved = Store.get('admin') === 'true';

//     // const target = typeof wp_dark_mode_admin_json !== 'undefined' ? wp_dark_mode_admin_json : wp_dark_mode_json;
//     if(isSaved && wp_dark_mode_admin_json.options?.admin_enabled) {
//         WPDarkMode.activate()
//     }


//     // Color correction.
//     // Log('Color correction');
//     // Color.init();
    

//     // Reactive Admin Dark Mode.
//     WPDarkMode.onChange(() => {
//         // Save the user choice of dark mode
//         Store.set('admin', WPDarkMode.isActive);

//         const HTML = document.querySelector('html');
//         // If active
//         if( WPDarkMode.isActive ) {
//             // add attribute data-wp-dark-mode to html tag
//             HTML.setAttribute('data-wp-dark-mode-active', 'true');
//         } else {
//             // remove attribute data-wp-dark-mode to html tag
//             HTML.removeAttribute('data-wp-dark-mode-active');
//         }
//     })
    
// });

// On Elementor init 
